module.exports = "::ng-deep svg {\n  display: block !important;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/helpers/mat-icon-dehoniane/mat-icon-dehoniane.component.css
// module id = ./src/app/helpers/mat-icon-dehoniane/mat-icon-dehoniane.component.css
// module chunks = main